import type { CityConfig } from "../city-template/types";

export const ranchoCucamongaConfig: CityConfig = {
  city: "Rancho Cucamonga",
  state: "California",
  stateAbbr: "CA",
  slug: "rancho-cucamonga",
  route: "/rancho-cucamonga",
  title: "Emergency Passport Rancho Cucamonga, CA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Rancho Cucamonga, CA — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for the Inland Empire and San Bernardino County. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Rancho Cucamonga, CA",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Rancho Cucamonga and Inland Empire travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Rancho%20Cucamonga%20California%20suburban%20landscape%20with%20modern%20residential%20communities%20and%20the%20majestic%20San%20Gabriel%20Mountains%20in%20the%20background%2C%20Victoria%20Gardens%20shopping%20district%20visible%2C%20warm%20golden%20hour%20sunset%20light%20over%20the%20Inland%20Empire%20foothills%2C%20clean%20modern%20planned%20city%20with%20wide%20boulevards%20and%20green%20landscaping%2C%20professional%20architectural%20photography%2C%20wide%20panoramic%20view%2C%20no%20visible%20text%20or%20people%2C%20warm%20earth%20tones%20and%20amber%20sky%20with%20mountain%20backdrop&width=1800&height=700&seq=rancho-cucamonga-hero-001&orientation=landscape",
  heroImageAlt: "Rancho Cucamonga California suburban landscape with San Gabriel Mountains backdrop at golden hour",
  geoPosition: "34.1064;-117.5931",
  geoPlacename: "Rancho Cucamonga, California",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Los Angeles Passport Agency",
    address: "11000 Wilshire Blvd Suite 1000, Los Angeles, CA 90024",
    distance: "Located in West LA — approximately 55–75 minutes from Rancho Cucamonga via I-10",
  },
  nearbyCitiesZips: [
    { name: "Rancho Cucamonga", zips: "91701, 91730, 91737, 91739" },
    { name: "Ontario", zips: "91761, 91762, 91764" },
    { name: "Upland", zips: "91784, 91786" },
    { name: "Fontana", zips: "92335, 92336, 92337" },
    { name: "Claremont", zips: "91711" },
    { name: "Montclair", zips: "91763" },
    { name: "San Bernardino", zips: "92401, 92404, 92405, 92407" },
    { name: "Riverside", zips: "92501, 92503, 92504, 92505" },
    { name: "Pomona", zips: "91766, 91767, 91768" },
    { name: "La Verne", zips: "91750" },
    { name: "Chino", zips: "91708, 91710" },
    { name: "Chino Hills", zips: "91709" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Inland Empire departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Los Angeles", route: "/los-angeles" },
    { name: "San Bernardino", route: "/san-bernardino" },
    { name: "Riverside", route: "/riverside" },
    { name: "Ontario", route: "/ontario" },
    { name: "Pasadena", route: "/pasadena" },
    { name: "Anaheim", route: "/anaheim" },
    { name: "Burbank", route: "/burbank" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Rancho Cucamonga remotely via secure courier. We do not have a walk-in office in Rancho Cucamonga — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Inland Empire travelers.",
  fpcOfficeAddress: "200 Spectrum Center Dr, Irvine, CA 92618",
  fpcOfficeDistance: "Serving all of the Inland Empire and San Bernardino County",
  serviceAreaIntro: "From the Victoria Gardens lifestyle center to the Terra Vista neighborhood, from the Foothill Boulevard corridor to the 210 Freeway area — Fast Passport Center serves the entire Rancho Cucamonga community. We regularly help travelers from Ontario, Upland, Fontana, and Chino Hills get their passports fast.",
  nearbyCitiesIntro: "We serve all Rancho Cucamonga neighborhoods and nearby Inland Empire cities including Ontario, Upland, Fontana, Claremont, Montclair, and Chino Hills. If you are in the Inland Empire or eastern Los Angeles County, we have you covered.",
  howItWorksIntro: "Most Rancho Cucamonga travelers complete everything online and ship documents overnight. No need to drive to Los Angeles or wait in line at the regional agency.",
  mistakesIntro: "With Ontario International Airport serving as the Inland Empire's primary gateway, Rancho Cucamonga travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Rancho Cucamonga and Inland Empire travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Rancho Cucamonga? Here are the most common ones we hear from Inland Empire travelers.",
  statePageRoute: "/states/california",
  statePageName: "California",
  dmvWebsite: "https://www.dmv.ca.gov",
  dmvLabel: "California DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Inland Empire international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Michael S.",
      location: "Rancho Cucamonga, CA",
      rating: 5,
      text: "My business trip to Germany was in 3 days and my passport was expired. Fast Passport Center got me a new one in 36 hours. Saved my trip completely.",
      service: "Emergency Passport",
    },
    {
      name: "Amanda R.",
      location: "Upland, CA",
      rating: 5,
      text: "Needed to renew for a family vacation to Cancun. The process was smooth, they reviewed my documents, and I had my passport in 4 days. Highly recommend.",
      service: "Passport Renewal",
    },
    {
      name: "Chris D.",
      location: "Fontana, CA",
      rating: 5,
      text: "Lost my passport the week before my honeymoon to Italy. They walked me through the DS-64 process and got me a replacement in 48 hours. Incredible service.",
      service: "Lost Passport",
    },
    {
      name: "Jessica L.",
      location: "Claremont, CA",
      rating: 5,
      text: "As a frequent international traveler from the Inland Empire, I can't afford passport delays. Fast Passport Center has been my go-to for years. Professional and reliable.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "rc-1",
      name: "Rancho Cucamonga Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10801 E Foothill Blvd",
      city: "Rancho Cucamonga",
      state: "CA",
      zip: "91730",
      phone: "(909) 989-8214",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from Victoria Gardens",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Acceptance hours are limited. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "rc-2",
      name: "Ontario Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "430 N Palo Verde St",
      city: "Ontario",
      state: "CA",
      zip: "91762",
      phone: "(909) 983-4671",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "2.5 miles from Ontario International Airport",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Busy location — book appointments 2+ weeks in advance. Limited weekend hours.",
      icon: "ri-mail-line",
    },
    {
      id: "rc-3",
      name: "Upland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "333 N Mountain Ave",
      city: "Upland",
      state: "CA",
      zip: "91786",
      phone: "(909) 982-4652",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.2 miles from downtown Upland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular location for Inland Empire residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "rc-4",
      name: "Fontana Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15049 Arrow Blvd",
      city: "Fontana",
      state: "CA",
      zip: "92335",
      phone: "(909) 822-9924",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.8 miles from Fontana City Hall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for San Bernardino County residents. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "rc-5",
      name: "Pomona Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E 3rd St",
      city: "Pomona",
      state: "CA",
      zip: "91766",
      phone: "(909) 622-3122",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.0 miles from Cal Poly Pomona",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern LA County residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "rc-6",
      name: "San Bernardino County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "222 W Hospitality Ln",
      city: "San Bernardino",
      state: "CA",
      zip: "92415",
      phone: "(909) 387-8312",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.5 miles from San Bernardino City Hall",
      website: "https://www.sbcounty.gov/",
      websiteLabel: "San Bernardino County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown LA", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "IE Foothill Coverage", agency: "No Inland Empire foothill expertise", fpc: "Victoria Gardens, IE business parks, and Inland Empire foothill travel expertise" },
    { feature: "Multi-Person Processing", agency: "Separate appointments per person", fpc: "Handle families and groups in parallel" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Inland Empire photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Inland Empire acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Inland Empire applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the LA regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Inland Empire families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Inland Empire travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Rancho Cucamonga." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Rancho Cucamonga address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Rancho Cucamonga before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Rancho Cucamonga for travelers with urgent international flights. Our registered couriers achieve 24–48 hour turnaround for most Inland Empire travelers." },
    { q: "How fast can I renew my passport in Rancho Cucamonga?", a: "Fast Passport Center offers fast passport renewal in Rancho Cucamonga in as little as 24–48 hours through our emergency courier service." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Rancho Cucamonga in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Rancho Cucamonga?", a: "Same-day passport appointments are only available at the LA Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Rancho Cucamonga residents." },
    { q: "Can I expedite a child passport in Rancho Cucamonga?", a: "Yes. Fast Passport Center expedites child passports in Rancho Cucamonga for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Rancho Cucamonga with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    {
      q: "How fast can I get a passport in Rancho Cucamonga?",
      a: "With Fast Passport Center's emergency courier service, Rancho Cucamonga travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays.",
    },
    {
      q: "Do I need to drive to the Los Angeles Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "Where are the closest passport acceptance facilities in Rancho Cucamonga?",
      a: "Popular options include the Rancho Cucamonga Post Office (91730), Ontario Post Office (91762), Upland Post Office (91786), and San Bernardino County Clerk (92415). All require appointments. We help you find the most convenient location and schedule your visit.",
    },
    {
      q: "Can I get a same-day passport in Rancho Cucamonga?",
      a: "Same-day passports are only available at the LA Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option.",
    },
    {
      q: "What if I live in Fontana, Chino Hills, or Eastvale?",
      a: "We serve all of the Inland Empire including Fontana, Chino Hills, Eastvale, and Corona. Our overnight shipping labels work from any UPS location, so your location within the Inland Empire doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Rancho Cucamonga?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline.",
    },
    {
      q: "Do you help with passport photos in Rancho Cucamonga?",
      a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Rancho Cucamonga and Ontario offer passport photo services. We review your photos before submission to ensure they meet State Department standards.",
    },
    {
      q: "What documents do I need for a first-time passport in Rancho Cucamonga?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Rancho Cucamonga?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Inland Empire families through the entire process and help schedule acceptance clerk appointments.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Rancho Cucamonga", address: "10601 E Foothill Blvd, Rancho Cucamonga, CA 91730", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Ontario", address: "1500 E Holt Blvd, Ontario, CA 91761", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Upland", address: "200 N Mountain Ave, Upland, CA 91786", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "UPS Store — Fontana", address: "15050 Summit Ave, Fontana, CA 92336", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — Chino Hills", address: "3943 Grand Ave, Chino Hills, CA 91709", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Claremont", address: "665 W Foothill Blvd, Claremont, CA 91711", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Postal Annex — Pomona", address: "1450 E Holt Ave, Pomona, CA 91767", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM" },
    { name: "Costco — San Bernardino", address: "1900 E Highland Ave, San Bernardino, CA 92404", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "DMV — Rancho Cucamonga",
      address: "9350 E Foothill Blvd, Rancho Cucamonga, CA 91730",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "DMV — Ontario",
      address: "1101 E Holt Blvd, Ontario, CA 91761",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Passport-ready photo services available. Online appointment booking.",
      featured: false,
    },
    {
      name: "DMV — Fontana",
      address: "16877 Merrill Ave, Fontana, CA 92335",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "DMV — San Bernardino",
      address: "655 E 3rd St, San Bernardino, CA 92415",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Full-service center for San Bernardino County residents.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "ONT",
      name: "Ontario International Airport",
      distance: "5 miles from Rancho Cucamonga",
      address: "1923 E Avion St, Ontario, CA 91761",
      note: "The primary airport for the Inland Empire. International flights to Mexico and connections to Asia and Europe.",
      flightUrl: "https://www.flyontario.com/",
      flightLabel: "Ontario Airport",
      featured: true,
    },
    {
      code: "LAX",
      name: "Los Angeles International Airport",
      distance: "50 miles from Rancho Cucamonga",
      address: "1 World Way, Los Angeles, CA 90045",
      note: "Major international hub for long-haul flights to Asia, Europe, and South America. Accessible via I-10.",
      flightUrl: "https://www.flylax.com/",
      flightLabel: "LAX Flight Info",
      featured: false,
    },
    {
      code: "BUR",
      name: "Hollywood Burbank Airport",
      distance: "45 miles from Rancho Cucamonga",
      address: "2627 N Hollywood Way, Burbank, CA 91505",
      note: "Domestic flights and some international connections. Less crowded than LAX.",
      flightUrl: "https://www.hollywoodburbankairport.com/",
      flightLabel: "Burbank Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from California CDPH Vital Records for San Bernardino County.", url: "https://www.cdph.ca.gov/Programs/CHSI/Pages/Vital-Records.aspx" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through California CDPH Vital Records.", url: "https://www.cdph.ca.gov/Programs/CHSI/Pages/Vital-Records.aspx" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the San Bernardino County Clerk-Recorder.", url: "https://www.sbcounty.gov/acr/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through San Bernardino County Superior Court.", url: "https://www.sb-court.org/" },
  ],
};